import { FC, ReactNode, useContext, useEffect } from "react";
import CguModal from "./CguModal";
import { AuthContext } from "../AuthContext";
import { usePostLoginModal } from "../PostLoginModalContext";

const CguProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { user } = useContext(AuthContext)!;
    const { currentModal, requestModal, dismissModal } = usePostLoginModal();

    useEffect(() => {
        const isUserAcceptedCgu = user?.termsAcceptedAt !== null;
        if (user && !isUserAcceptedCgu) {
            requestModal("cgu");
        }
    }, [user, requestModal]);

    const isModalOpen = currentModal === "cgu";
    const setIsModalOpen = (open: boolean) => {
        if (!open) dismissModal();
    };

    return (
        <>
            <CguModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
            />
            {children}
        </>
    );
};

export default CguProvider;
